import { createContext } from "react";
import { useState, useContext } from "react";
import MySnackbar from "../components/SnackBar";

const SnackBarContext = createContext();

export const SnackBarPovider = ({ children }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  function showHideSnackBar(message) {
    setOpenSnackBar(true);
    setSnackBarMessage(message);
    setTimeout(() => {
      setOpenSnackBar(false);
    }, 2000);
  }

  return (
    <SnackBarContext.Provider value={{ showHideSnackBar }}>
      <MySnackbar open={openSnackBar} message={SnackBarMessage} />
      {children}
    </SnackBarContext.Provider>
  );
};

export const useSnackBar = () => {
  return useContext(SnackBarContext);
};
